URL = '/keepcon/settings/operator_statuses'
class AccountSettings.OperatorStatus extends Backbone.Model
  getType: ->
    @get('type').split('::').pop().replace('OperatorStatus','')


class AccountSettings.OperatorStatusCollection extends Backbone.Collection
  model: AccountSettings.OperatorStatus
  url: URL

  updatePositions: (originalPosition, newPosition) ->
    return this if originalPosition == newPosition
    temp = @at(originalPosition)
    @remove(temp, { silent: true })
    @add(temp, { at: newPosition, silent: true })
    return Backbone.ajax({
      url: @url + '/sort',
      method: 'POST',
      data: { ids: @pluck('id') },
      dataType: "json",
    });
